import {Injectable} from '@angular/core';
import {Effect, Actions} from '@ngrx/effects';
import {AuthService} from '../../auth.service';
import * as authAction from '../actions/auth.actions';
import {map, switchMap, catchError, mergeMap, take} from 'rxjs/operators';
import {of} from 'rxjs/observable/of';
import {Action} from '@ngrx/store';
import {Observable} from 'rxjs/Observable';


@Injectable()
export class AuthEffect {
  constructor(private actions: Actions, private auth: AuthService) {
  }

  @Effect()
  loginUser: Observable<Action> = this.actions.ofType(authAction.LOGIN_USER)
    .map((action: authAction.LoginUser) => action.payload)
    .pipe(
      switchMap((user) => {
        return this.auth.signIn(user).map(_user => {
          if (_user.accountType === 'admin') {
            return new authAction.LoginUserSuccess(_user);
          } else {
            this.auth.signOut();
            return new authAction.LoginUserFail('Access denied');
          }
        }).catch(error => of(new authAction.LoginUserFail('Invalid Login Credentials')));
      }));


  @Effect({dispatch: false})
  logoutUser: Observable<Action> = this.actions.ofType(authAction.LOGOUT_USER)
    .map(() => {
      this.auth.signOut();
      return new authAction.LogoutUser();
    });


}




// WEBPACK FOOTER //
// /Users/Chetan/Downloads/angular5_admin-master/src/app/store/effects/auth.effect.ts